import styled from 'styled-components';
import { SRow } from 'styles/layout';

export const SBreadcrumb = styled(SRow)`
    gap: 0.5rem;
`;
